import React from 'react';

import { DefaultView, EditView, Views as BlockWithViews } from '../../types/BlockWithViews';
import { asFetchableBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { RegistrationValidityTextEditView } from './views/RegistrationValidityTextEditView';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { PortalSettingsDefaultView } from '../../_lib/components/PortalSettingsDefaultView';
import { HeadingHierarchy } from '../../_lib/components/Heading/Heading';

type RegistrationEmailSettings = BlockWithViews<DefaultView<{ value: string }> & EditView<any>>;
function RegistrationValidityText({ views, activeView }: RegistrationEmailSettings) {
  const { t } = useSonTranslation('RegistrationValidityText');
  const { uuid, elementType } = useBlockContext();

  const headline: { text: string, hierarchy: HeadingHierarchy, visible: true } = {
    text: t('headline'),
    hierarchy: 2,
    visible: true,
  };

  const buttons = createButtonObject(
    Views.EDIT,
    Icons.EDIT_PENCIL,
    `RegistrationValidityText:edit`,
    DISPLAY_TYPE.COLLAPSIBLE,
    <RegistrationValidityTextEditView {...views.edit} />,
  );

  return (
    <BlockInteractions
      headline={headline}
      alwaysShowInfo
      views={views}
      activeView={activeView}
      buttons={buttons}
      uuid={uuid}
      elementType={elementType}
    >
      <PortalSettingsDefaultView {...views.default} noContentMessage={t('noContent')} />
    </BlockInteractions>
  );
}

export const RegistrationValidityTextBlock = asFetchableBlock(RegistrationValidityText, BlockType.registrationEmail);
